
import { useEffect, useRef } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'

import { useAuth } from '../../Shared/Contexts/AuthContext'
import { useGlobalContext } from '../../Shared/Contexts/GlobalContext'

const ProtectedRoutes = () => {
  const { authState, currentUser: { isCurrentOrganizationLocked, selfOrganizations, currentOrganizationKey } } = useAuth()
  const { openLockedOrganizationDialog, lockedOrganizationDialog } = useGlobalContext()
  const navigate = useNavigate()
  const location = useLocation()
  const hasShownDialog = useRef(false)

  useEffect(() => {
    if (lockedOrganizationDialog) {
      hasShownDialog.current = true
    }
    if (!isCurrentOrganizationLocked) {
      hasShownDialog.current = false
    }
  }, [lockedOrganizationDialog, isCurrentOrganizationLocked, currentOrganizationKey])

  useEffect(() => {
    if (authState.isAuthenticated && isCurrentOrganizationLocked && location.pathname !== '/management/profile') {
      navigate('/management/profile')
    }
  }, [authState.isAuthenticated, isCurrentOrganizationLocked, location.pathname])

  useEffect(() => {
    if (authState.isAuthenticated && isCurrentOrganizationLocked && !lockedOrganizationDialog && !hasShownDialog.current) {
      const currentOrganization = selfOrganizations?.find(org => org.key === currentOrganizationKey)
      hasShownDialog.current = true
      openLockedOrganizationDialog(currentOrganization?.name || currentOrganizationKey)
    }
  }, [authState.isAuthenticated, isCurrentOrganizationLocked, lockedOrganizationDialog])

  return authState.isAuthenticated ? <Outlet /> : <Navigate to="/" />
}

export default ProtectedRoutes
